/***************************************************************************************
* FileName      : TaxHistory.js
* Description   : 해와관리자 > 정산 > 부가세내역
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2023.12.14
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import {Row, Col, Button , Navbar, Nav, Container} from 'react-bootstrap';

import { useAdjustTaxDocumentQuery , handleAdjustTaxSearch } from '../../../api/hwadmin/adjustApi';

import React, { useState , useEffect } from 'react';
import Pagination from '../common/Pagination'
import { AdjustRow } from './TaxHistory/AdjustRow';

import SortComponent from '../common/SortComponent2';
import PageSizeSelect from '../common/PageSizeSelect';
import SelectVendor from '../product/Component/SelectVendor';

function TaxHistory()
{    
    const [ordering, setOrdering] = useState('-created_at');
    const [pageSize, setPageSize] = useState(10); 

    const { data, error, isFetching, page, setPage } = useAdjustTaxDocumentQuery(ordering,pageSize);
    
 
    const [searchResults, setSearchResults] = useState([]);
    const [searchConfirm, setSearchConfirm] = useState(false);

    const [searchUrl, setSearchUrl] = useState('');

    //날짜 옵션 선택
    const [selectedStartDate, setSelectedStartDate] = useState('');
    const [selectedEndDate, setSelectedEndDate] = useState('');

    console.log(data)
    console.log("데이터")

    // 선택한 수산상회 
    const [selectedVendor, setSelectedVendor] = useState({ id: null, name: "" });


    // 날짜 값 변화
    const handleStartDateChange = (event) => {
        setSelectedStartDate(event.target.value);
    };
    const handleEndDateChange = (event) => {
        setSelectedEndDate(event.target.value);
    };

    const handlePrevPage = () => {
        setPage(prevPage => prevPage - 1);
    };
    
    const handleNextPage = () => {
        setPage(prevPage => prevPage + 1);
    };

    const onSearch = () => {
        handleAdjustTaxSearch({
            setSearchResults,
            setSearchUrl,
            selectedStartDate,
            selectedEndDate, 
            selectedVendor
        });

        setSearchConfirm(true);
    };

    const handleResetClick = () => {
        window.location.href = '/admin/settle/TaxHistory'; 
    };

    // 가입순 정렬 데이터 변화
    const handleOrderingChange = (event) => {
        setOrdering(event.target.value);
    };
    
    // 10개씩 50개씩 100개씩
    const handlePageSizeChange = (event) => {
        console.log(event.target.value)
        setPageSize(parseInt(event.target.value));
    };


    return(
        <>
        <div className='mainContents'>
            {/* 부가세내역 */}
            <div className='page-tit'>
                <h2>부가세내역</h2>
            </div>

            {/* 검색 */}
            <section className='McontentBox m-p0'>
                <div className='search-wrap'>
                    <div className='search-field date'>
                        <div> 
                            <b>부가세 신고기간</b> 
                        </div>
                        <div>
                            <input type="date" value={selectedStartDate} onChange={handleStartDateChange} />
                            <input type="date" value={selectedEndDate} onChange={handleEndDateChange} />
                        </div>   
                    </div>
                    <div className='search-field division'>
                        <div> 
                            <b>수산상회</b> 
                        </div>
                        <div>
                            <SelectVendor 
                                selectedVendor={selectedVendor}
                                setSelectedVendor={setSelectedVendor}
                                />   
                          
                        </div>   
                    </div>
                
                </div>
                <div className='m-btn-wrap'>
                    <button className='m-btn' onClick={handleResetClick}>초기화</button>
                    <button className='m-btn m-btn-search'  onClick={onSearch}>검색</button>
                  
                </div>
            </section>
            {/* 검색 결과 */}
            <section className='McontentBox'>
                <div className='subTitle'>
                    <div className='selectWrap'>
                        <span>검색결과</span>
                        <span className='result-wrap'>
                            {searchConfirm && searchResults.totalCnt > 0 ? (
                                <>
                                    <p>(총 <b className='sum-s-b'>{searchResults.totalCnt}</b>개)</p>
                                </>
                                ) : (
                                <>
                                    <p>(총 <b className='sum-s-b'>{data?.totalCnt ? data?.totalCnt : 0}</b>개)</p>
                                </>
                            )}
                        </span>
                    </div>

                    { !searchConfirm && 
                    <div className='selectWrap'>
                        <SortComponent
                            ordering={ordering}
                            handleOrderingChange={handleOrderingChange}
                            newLabel="최근날짜순"
                            oldLabel="오래된날짜순"
                        />
                        <PageSizeSelect value={pageSize} onChange={handlePageSizeChange} />
                    </div>
                    }
                </div>
                <div className='m-btn-wrap-sm'>
                    <button className='m-sm-btn'>다운로드</button>
                </div>

                <div className='fixTable_wrap'>
                    <table className='sTable' id='scrollTable'>
                        <colgroup>
                                {/* <col style="width:10%"/>
                                <col style="width:10%"/>
                                <col style="width:10%"/>
                                <col style="width:10%"/>
                                <col style="width:10%"/> */}
                        </colgroup>
                        <thead>
                            <tr>
                               <th rowspan="2">
                                    <input type="checkbox"/>
                               </th>
                               <th rowspan="2">부가세 신고기간</th>
                               <th rowspan="2">수산상회</th>
                               <th colspan="2">매출구분</th>
                               <th colspan="4">상세내역</th>
                            </tr>
                            <tr>
                                <th>과세매출</th>  
                                <th>면세매출</th>
                                <th>신용카드매출전표</th>
                                <th>소득공제</th>
                                <th>지출증빙</th>
                                <th>기타</th>
                            </tr>           
                        </thead>
                        <tbody>
                            {searchConfirm && searchResults?.count === 0 ? (
                                <tr>
                                    <td colSpan="17">검색 결과가 없습니다.</td>
                                </tr>
                            ) : searchResults?.count > 0 ? (
                                searchResults?.data.map((Adjust , index) => (
                                    <AdjustRow 
                                        index={index} 
                                        Adjust={Adjust}/>
                                
                                ))
                            ) : data && data?.data && data?.data.length > 0 ? (
                                data?.data.map((Adjust , index ) => (
                                    <AdjustRow 
                                        index={index} 
                                        Adjust={Adjust}/>
                                
                                ))
                            ) : null}

                        </tbody>
                    </table>
                </div>
            </section>

             {/* 페이지내비게이션 */}
             <section>
                {searchConfirm && searchResults?.count === 0 ? (
                    <>
                    </>
                ) : searchResults?.count > 0 ? (
                        <Pagination
                            count={searchResults?.count}
                            page={page}
                            setPage={setPage}
                            pageSize={pageSize}
                            handlePrevPage={handlePrevPage}
                            handleNextPage={handleNextPage}
                    />
                ) : (
    
                    <Pagination
                        count={data?.totalCnt || 0}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                    />
                )}
            </section>
            </div>

        </>
    )
}

export default TaxHistory